export default __webpack_public_path__ + "static/eagle_eye-min-3778eca66d5f942f87dd96fd0dcf9645.png";